import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CaretRightIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "caret-right",
  "CaretRightIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M11.3335 8L5.00016 12L5.00016 4L11.3335 8Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default CaretRightIcon;
